import styled from 'styled-components';

import {
  convertPxToRem,
  InterFont,
  paragraphs,
  titles
} from '@proprioo/salatim';

export const LayoutUserError = styled.div`
  width: 100%;
  margin: ${convertPxToRem(16)} 0;
  padding: 0;
`;

export const Title = styled.div`
  ${titles.h4};
  ${InterFont};
  color: white;
  margin-bottom: ${convertPxToRem(16)};
`;

export const CheckboxWrapper = styled.div`
  margin-top: ${convertPxToRem(24)};
`;

export const HelperProcedure = styled.div`
  ${paragraphs.caption};
  margin-top: ${convertPxToRem(8)};
  font-weight: bold;
`;
